/**
 * Checks if the current environment has a window object.
 *
 * @return {boolean} true if the environment has a window object, otherwise false.
 */
export function hasWindow(): boolean {
  return typeof window === 'object' && window !== null && window.self === window
}
